(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28967,57387],{

/***/ 77472:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/products/[sku]",
      function () {
        return __webpack_require__(548414);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 393957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ formatExtraPromotions; }
/* harmony export */ });
const formatExtraPromotions = (extraPromotions, type)=>{
    return extraPromotions.map((promotion)=>({
            promotionType: type,
            benefit: {
                data: promotion
            }
        }));
};


/***/ }),

/***/ 115674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useVnpayPromotion; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268711);



const useVnpayPromotion = (vnPayPromotionCode)=>{
    const { data , error  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)([
        "/magento/customdata/".concat(vnPayPromotionCode),
        vnPayPromotionCode
    ], (_url, code)=>{
        return _services__WEBPACK_IMPORTED_MODULE_1__/* .magentoService.getCustomData */ .c.getCustomData(code).then((res)=>{
            var ref;
            return Object.values(((ref = res.data) === null || ref === void 0 ? void 0 : ref.data) || {}).map((promotion)=>(0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .transformExtraPromotion */ .Y2)(promotion)).filter((promotion)=>promotion.date && (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .checkExpiryDate */ .N6)(promotion.date.startDate, promotion.date.endDate));
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        vnpayPromotions: data || [],
        loading: !data && !error
    };
};


/***/ }),

/***/ 548414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var tenants_phongvu_desktop_products_sku___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(945656);
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (tenants_phongvu_desktop_products_sku___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 268711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ magentoService; }
/* harmony export */ });
/* harmony import */ var _clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44844);

class MagentoService {
    async getBanks() {
        return await _clients__WEBPACK_IMPORTED_MODULE_0__/* .serverApi.get */ .I1.get("/banks");
    }
    async getCustomData(code) {
        return await _clients__WEBPACK_IMPORTED_MODULE_0__/* .magentoApi.get */ ._6.get("/content/getCustomData", {
            params: {
                code
            }
        });
    }
    async getCampaigns(limit, p) {
        return await _clients__WEBPACK_IMPORTED_MODULE_0__/* .magentoApi.get */ ._6.get("/promotion/getPromoCampaigns", {
            params: {
                limit,
                p
            }
        });
    }
    async getShowrooms(products) {
        return _clients__WEBPACK_IMPORTED_MODULE_0__/* .magentoApi.post */ ._6.post("/address/showrooms", products).then((res)=>res.data);
    }
    // 23: desktop, 27: mobile
    async getContactContent(store) {
        return _clients__WEBPACK_IMPORTED_MODULE_0__/* .magentoApi.get */ ._6.get("/address/getContact?store=".concat(store)).then((param)=>{
            let { data  } = param;
            return (data === null || data === void 0 ? void 0 : data.html_content) || "";
        });
    }
}
const magentoService = new MagentoService();


/***/ }),

/***/ 953067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useCustomPromotion; }
/* harmony export */ });
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268711);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);



const useCustomPromotion = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)([
        "/magento/customdata/custom_promo_text",
        "custom_promo_text"
    ], (_url, code)=>{
        return services__WEBPACK_IMPORTED_MODULE_1__/* .magentoService.getCustomData */ .c.getCustomData(code).then((res)=>{
            var ref;
            return Object.values(((ref = res.data) === null || ref === void 0 ? void 0 : ref.data) || {}).map((promotion)=>(0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .transformExtraPromotion */ .Y2)(promotion)).filter((promotion)=>promotion.date && (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .checkExpiryDate */ .N6)(promotion.date.startDate, promotion.date.endDate));
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        customPromotions: data || []
    };
};


/***/ }),

/***/ 945656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getServerSideProps */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(534924);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(393957);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(115674);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(684443);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(857387);
/* harmony import */ var _module_hooks_useCustomPromotions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(953067);









const NewDetailPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(19303), __webpack_require__.e(4545), __webpack_require__.e(76414), __webpack_require__.e(81633), __webpack_require__.e(22295), __webpack_require__.e(44303), __webpack_require__.e(85541), __webpack_require__.e(31917), __webpack_require__.e(37340), __webpack_require__.e(2026), __webpack_require__.e(43290), __webpack_require__.e(52136), __webpack_require__.e(69878), __webpack_require__.e(67406), __webpack_require__.e(47845), __webpack_require__.e(92414), __webpack_require__.e(43610), __webpack_require__.e(27779), __webpack_require__.e(41565)]).then(__webpack_require__.bind(__webpack_require__, 248225)).then((mod)=>mod.NewDetailPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(248225)
            ]
    }
});
const DetailPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(19303), __webpack_require__.e(4545), __webpack_require__.e(76414), __webpack_require__.e(81633), __webpack_require__.e(22295), __webpack_require__.e(44303), __webpack_require__.e(85541), __webpack_require__.e(31917), __webpack_require__.e(37340), __webpack_require__.e(2026), __webpack_require__.e(43290), __webpack_require__.e(52136), __webpack_require__.e(69878), __webpack_require__.e(67406), __webpack_require__.e(47845), __webpack_require__.e(92414), __webpack_require__.e(43610), __webpack_require__.e(27779), __webpack_require__.e(41565)]).then(__webpack_require__.bind(__webpack_require__, 248225)).then((mod)=>mod.DetailPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(248225)
            ]
    }
});
const ProductDetails = ()=>{
    const { vnpayPromotions  } = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useVnpayPromotion */ .h)("phongvu_vnpay_promotion");
    const { customPromotions  } = (0,_module_hooks_useCustomPromotions__WEBPACK_IMPORTED_MODULE_4__/* .useCustomPromotion */ .f)();
    const { epicOmni1643  } = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useTenantConfig */ .Wx)();
    const extraPromotions = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .formatExtraPromotions */ .E)(vnpayPromotions, types__WEBPACK_IMPORTED_MODULE_7__/* .PROMOTION_TYPE.magento */ .j.magento);
    const extraCustomPromotions = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .formatExtraPromotions */ .E)(customPromotions, types__WEBPACK_IMPORTED_MODULE_7__/* .PROMOTION_TYPE.customMagento */ .j.customMagento);
    if (epicOmni1643) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewDetailPage, {
        showRelatedPromotion: true,
        extraPromotions: [
            ...extraPromotions,
            ...extraCustomPromotions
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DetailPage, {
        extraPromotions: [
            ...extraPromotions,
            ...extraCustomPromotions
        ]
    });
};
const ProductDetailsPage = (param)=>{
    let { serverProduct , inlineBanners  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(contexts__WEBPACK_IMPORTED_MODULE_8__/* .ProductDetailProvider */ .D, {
        serverProduct: serverProduct,
        inlineBanners: inlineBanners,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductDetails, {})
    });
};
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsDetail));
/* harmony default export */ __webpack_exports__["Z"] = (ProductDetailsPage);


/***/ }),

/***/ 857387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PROMOTION_TYPE; },
/* harmony export */   "s": function() { return /* binding */ BENEFIT_TYPE; }
/* harmony export */ });
var BENEFIT_TYPE;
(function(BENEFIT_TYPE) {
    BENEFIT_TYPE["voucher"] = "voucher";
    BENEFIT_TYPE["gifts"] = "gifts";
    BENEFIT_TYPE["discount"] = "discount";
})(BENEFIT_TYPE || (BENEFIT_TYPE = {}));
var PROMOTION_TYPE;
(function(PROMOTION_TYPE) {
    PROMOTION_TYPE["magento"] = "magento";
    PROMOTION_TYPE["customMagento"] = "customMagento";
})(PROMOTION_TYPE || (PROMOTION_TYPE = {}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [34924,93712,49774,92888,40179], function() { return __webpack_exec__(77472); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);